import React from 'react'
import styles from './style.module.scss'

interface BlueGridContainerProps {
  children?: React.ReactNode
  className?: string
}

const BlueGridContainer: React.FC<BlueGridContainerProps> = ({ children, className }) => {
  return (
    <div className={`${styles.container} ${className || ''}`}>
      {children}
    </div>
  )
}

export default BlueGridContainer
